import Menu from "../../data/menu.json"

const getFilteredData = (role) => {
  const roleName = role ? role.toLowerCase() : '';
  if (roleName === 'customer') {
    return Menu.data.filter(item => {
      return ['Orders', 'Payments', 'Dashboard'].includes(item.title) || item.type === 'headtitle';
    });
  } else if (roleName === 'staff') {
    return Menu.data.filter(item => {
      return ['Orders', 'Scan Order', 'Dashboard'].includes(item.title) || item.type === 'headtitle';
    });
  } else if (roleName === 'operation') {
    return Menu.data.filter(item => {
      return ['Orders', 'Parcels', 'Manifests', 'Service Prices', 'Customer', 'Customer Rank', 'Service', 'Payments', 'Dashboard', 'Scan Order'].includes(item.title) || item.type === 'headtitle';
    });
  } else if (roleName === 'sale') {
    return Menu.data.filter(item => {
      return ['Orders', 'Customer', 'Customer Rank', 'Payments', 'Dashboard'].includes(item.title) || item.type === 'headtitle';
    });
  } else if (roleName === 'accountant') {
    return Menu.data.filter(item => {
      return ['Orders', 'Balance Histories', 'Payments', 'Dashboard'].includes(item.title) || item.type === 'headtitle';
    });
  } else if (roleName === 'guest') {
    return Menu.data.filter(item => item.type === 'headtitle'); // Minimal items for guest
  } else if (!roleName) {
    return []; // Empty while loading or not logged in
  } else {
    // Admin or other roles get everything
    return Menu.data;
  }
}

const state ={
data: getFilteredData(localStorage.getItem('user_role')),
togglesidebar: true,
  sidebarPinned: localStorage.getItem('sidebar_pinned') !== '0',
  activeoverlay : false,
  customizer: '',
  searchData: [],
  searchOpen : false,
  hideRightArrowRTL: false,
  hideLeftArrowRTL: true,
  hideRightArrow: true,
  hideLeftArrow: true,
  width: 0,
  height: 0,
  margin: 0,
  menuWidth: 0,
};
const mutations = {
  searchTerm: (state, term) => {

    let items = [];
    var searchval = term.toLowerCase();
    state.data.filter(menuItems => {
      
      if (menuItems.title) {
        if (menuItems.title.toLowerCase().includes(searchval) && menuItems.type === 'link') {
          items.push(menuItems);
        }
        if (!menuItems.children) return false;
        menuItems.children.filter(subItems => {
          if (subItems.title.toLowerCase().includes(searchval) && subItems.type === 'link') {
            subItems.icon = menuItems.icon;
            items.push(subItems);
          }
          if (!subItems.children) return false;
          subItems.children.filter(suSubItems => {
            if (suSubItems.title.toLowerCase().includes(searchval)){
              suSubItems.icon = menuItems.icon;
              items.push(suSubItems);
            }
          });
        });
        state.searchData = items;
      }
    });
  },
  opensidebar: (state) => {
    state.togglesidebar = !state.togglesidebar;
    if (window.innerWidth < 1001) {
      state.activeoverlay = state.togglesidebar;
    } else {
      state.activeoverlay = false;
    }
  },
  resizetoggle: (state) => {
    if (window.innerWidth <= 1199) {
      state.togglesidebar = false;
    
    } else {
      state.togglesidebar = true;
    
    }
  },
  setNavActive: (state, item) => {
    if (!item.active) {
      state.data.forEach(a => {
        if (state.data.includes(item))
          a.active = false;
        if (!a.children) return false;
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  },
  setActiveRoute: (state, item) => {
    state.data.filter(menuItem => {
      if (menuItem !== item)
        menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true;
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  },
  setRole: (state, role) => {
    state.data = getFilteredData(role);
  },
  toggleSidebarPin: (state) => {
    state.sidebarPinned = !state.sidebarPinned;
    localStorage.setItem('sidebar_pinned', state.sidebarPinned ? '1' : '0');
  }
};
const actions = {
  setNavActive: (context,item) => {
    context.commit('setNavActive', item);
  },
  opensidebar: (context, term) => {
    context.commit('opensidebar', term);
  },
  resizetoggle: (context, term) => {
    context.commit('resizetoggle', term);
  },
  searchTerm: (context, term) => {
    context.commit('searchTerm', term);
  },
  setActiveRoute: (context, item) => {
    context.commit('setActiveRoute', item);
  },
  setRole: (context, role) => {
    context.commit('setRole', role);
  },
  toggleSidebarPin: (context) => {
    context.commit('toggleSidebarPin');
  }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
  };
